import { useEffect, useState } from "react"
import { getLightLandingLogo } from "@/lib/siteHosts"
import { focusRing } from "../lightTheme"

const headerLinkClass = `hidden h-8 shrink-0 items-center text-[14px] font-medium leading-[21px] text-[#171717] no-underline hover:text-[#4D4D4D] md:inline-flex ${focusRing}`

const reportNav = [
  { href: "#methodology", label: "Methodology" },
  { href: "#database-lookup", label: "Database Lookup" },
  { href: "#key-findings", label: "Key Findings" },
]

export default function LightHeader() {
  const logo = getLightLandingLogo()
  const [scrolled, setScrolled] = useState(
    () => typeof window !== "undefined" && window.scrollY > 0
  )

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0)
    onScroll()
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <header
      className={`sticky top-0 z-50 h-16 w-full ${
        scrolled
          ? "bg-[#FAFAFA] shadow-[0_1px_0_0_rgba(0,0,0,0.08)]"
          : "bg-transparent shadow-none"
      }`}
    >
      <div className="mx-auto flex h-full w-full max-w-[1400px] items-center justify-between gap-3 px-6">
        <button type="button" className="cursor-pointer">
          <img
            src={logo.src}
            alt={logo.alt}
            className="h-[18px] w-auto md:h-6"
          />
        </button>
        <div className="flex items-center gap-4">
          {reportNav.map((item) => (
            <a key={item.href} href={item.href} className={headerLinkClass}>
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  )
}
